import { gql } from '@apollo/client';
const ACTIVATE_MODEL_SIZE = gql `
  mutation ActivateModelSize($modelSpecificationSizeId: ID!) {
    activateModelSpecificationSize(modelSpecificationSizeId: $modelSpecificationSizeId) {
      modelSpecificationSize {
        id
        isActive
        sizeName {
          id
          name
        }
      }
    }
  }
`;
export default ACTIVATE_MODEL_SIZE;
